/* Bloques */
var calcularBloques = function() {
  "use strict";
  /* Variables */
  var bloquesBtn = document.getElementById("bloques-btn"),
      bloquesUnits = document.getElementById("bloques-units"),
      bloquesWidth = document.getElementById("bloques-width"),
      bloquesHeight = document.getElementById("bloques-height"),
      bloquesAnswer = document.getElementById("bloques-error"),
      bloquesUnitsResult = "",
      bloquesAreaResult = "",
      bloquesBloques6Result = "",
      bloquesPiedraResult = "",
      bloquesBloques4Result = "",
      bloquesCementoResult = "",
      bloquesArenaResult = "",
      bloquesAceroResult = "",
      bloquesSikaResult = "",
      bloquesResults = document.getElementById("bloques-results"),
      bloquesArea = document.getElementById("bloques-area"),
      bloquesSizes = document.getElementById("bloques-sizes"),
      bloquesTipo6 = document.getElementById("bloques-tipo-6"),
      bloquesPiedra = document.getElementById("bloques-piedra"),
      bloquesTipo4 = document.getElementById("bloques-tipo-4"),
      bloquesCemento = document.getElementById("bloques-cemento"),
      bloquesArena = document.getElementById("bloques-arena"),
      bloquesAcero = document.getElementById("bloques-acero"),
      bloquesSika = document.getElementById("bloques-sika");

  bloquesBtn.addEventListener("click", function(e) {
    e.preventDefault();
    /* Operación */
    bloquesUnitsResult = (bloquesUnits.value);
    bloquesAreaResult = (bloquesWidth.value * bloquesHeight.value);

    if(bloquesUnitsResult == 'metros') {
      bloquesBloques6Result = (bloquesWidth.value * 2.2);
      bloquesPiedraResult = (bloquesBloques6Result / 1.5);
      bloquesBloques4Result = (bloquesWidth.value * bloquesHeight.value * 11);
      bloquesCementoResult = ((1 / 50) * bloquesBloques4Result);
      bloquesArenaResult = (bloquesCementoResult * 10.72);
      bloquesAceroResult = ((bloquesWidth.value / 1.83) * bloquesHeight.value * (1 / 9));
      bloquesSikaResult = (bloquesCementoResult * 0.5);
    } else {
      bloquesBloques6Result = ((bloquesWidth.value * 12) / 18);
      bloquesPiedraResult = (bloquesBloques6Result / 2);
      bloquesBloques4Result = (((bloquesWidth.value * bloquesHeight.value) / 10.76) * 11);
      bloquesCementoResult = ((1 / 50) * bloquesBloques4Result);
      bloquesArenaResult = (bloquesCementoResult * 10.72);
      bloquesAceroResult = ((bloquesWidth.value / 6) * bloquesHeight.value * (1 / 30));
      bloquesSikaResult = (bloquesCementoResult * 0.5);
    }
    
    if (bloquesAreaResult > 0) {
      bloquesResults.classList.add("active-results");
      bloquesArea.innerHTML = bloquesAreaResult.toFixed(2);
      bloquesSizes.innerHTML = bloquesUnitsResult + '²';
      bloquesTipo6.innerHTML = Math.round(bloquesBloques6Result);
      bloquesPiedra.innerHTML = Math.round(bloquesPiedraResult);
      bloquesTipo4.innerHTML = Math.round(bloquesBloques4Result);
      bloquesCemento.innerHTML = bloquesCementoResult.toFixed(2);
      bloquesArena.innerHTML = Math.round(bloquesArenaResult);
      bloquesAcero.innerHTML = (Math.round(bloquesAceroResult * 10) / 10);
      bloquesSika.innerHTML = bloquesSikaResult.toFixed(2) + 'Kg';
      bloquesAnswer.innerHTML = "";
    } else {
      bloquesResults.classList.remove("active-results");
      bloquesAnswer.innerHTML = "*Dimensiones inválidas. Complete los campos.";
    }
  });
}();


/* Repello */
var repelloUnitsSelect = document.getElementById("repello-units");
var repelloUnitsText = document.getElementById("repello-units-result");

repelloUnitsSelect.addEventListener("change", (event) => {
  var repelloUnitsSelectValue = document.getElementById("repello-units");
  if (repelloUnitsSelectValue.value == 'metros') {
    var repelloUnitsSelectUnit = '(milímetros)';
  } else {
    var repelloUnitsSelectUnit = '(pulgadas)';
  }
  repelloUnitsText.innerHTML = repelloUnitsSelectUnit;
});

var calcularRepello = function() {
  "use strict";
  /* Variables */
  var repelloBtn = document.getElementById("repello-btn"),
      repelloUnits = document.getElementById("repello-units"),
      repelloWidth = document.getElementById("repello-width"),
      repelloHeight = document.getElementById("repello-height"),
      repelloEspesor = document.getElementById("repello-espesor"),
      repelloAnswer = document.getElementById("repello-error"),
      repelloUnitsResult = "",
      repelloAreaResult = "",
      repelloCementoResult = "",
      repelloArenaResult = "",
      repelloSikaResult = "",
      repelloResults = document.getElementById("repello-results"),
      repelloArea = document.getElementById("repello-area"),
      repelloSizes = document.getElementById("repello-sizes"),
      repelloCemento = document.getElementById("repello-cemento"),
      repelloArena = document.getElementById("repello-arena"),
      repelloSika = document.getElementById("repello-sika");

  repelloBtn.addEventListener("click", function(e) {
      e.preventDefault();
      /* Operación */
      repelloUnitsResult = (repelloUnits.value);

      if(repelloUnitsResult == 'metros') {
      repelloAreaResult = (repelloWidth.value * repelloHeight.value * (repelloEspesor.value / 1000));
      repelloCementoResult = (repelloAreaResult * 7);
      repelloArenaResult = (repelloCementoResult * 8);
      repelloSikaResult = (repelloCementoResult * 0.5);
      } else {
      repelloAreaResult = (repelloWidth.value * repelloHeight.value * (repelloEspesor.value / 12));
      repelloCementoResult = ((repelloAreaResult / 35.3) * 7);
      repelloArenaResult = (repelloCementoResult * 8);
      repelloSikaResult = (repelloCementoResult * 0.5);
      }
      
      if (repelloAreaResult > 0) {
      repelloResults.classList.add("active-results");
      repelloArea.innerHTML = repelloAreaResult.toFixed(3);
      repelloSizes.innerHTML = repelloUnitsResult + '³';
      repelloCemento.innerHTML = repelloCementoResult.toFixed(2);
      repelloArena.innerHTML = (repelloArenaResult).toFixed(1);
      repelloSika.innerHTML = repelloSikaResult.toFixed(2) + 'Kg';
      repelloAnswer.innerHTML = "";
      } else {
      repelloResults.classList.remove("active-results");
      repelloAnswer.innerHTML = "*Dimensiones inválidas. Complete los campos.";
      }
  });
}();


/* Concreto */
var concretoUnitsSelect = document.getElementById("concreto-units");
var concretoUnitsText = document.getElementById("concreto-units-result");

concretoUnitsSelect.addEventListener("change", (event) => {
  var concretoUnitsSelectValue = document.getElementById("concreto-units");
  if (concretoUnitsSelectValue.value == 'metros') {
    var concretoUnitsSelectUnit = '(centímetros)';
  } else {
    var concretoUnitsSelectUnit = '(pulgadas)';
  }
  concretoUnitsText.innerHTML = concretoUnitsSelectUnit;
});

var calcularconcreto = function() {
  "use strict";
  /* Variables */
  var concretoBtn = document.getElementById("concreto-btn"),
      concretoUnits = document.getElementById("concreto-units"),
      concretoWidth = document.getElementById("concreto-width"),
      concretoHeight = document.getElementById("concreto-height"),
      concretoEspesor = document.getElementById("concreto-espesor"),
      concretoAnswer = document.getElementById("concreto-error"),
      concretoUnitsResult = "",
      concretoAreaResult = "",
      concretoCementoResult = "",
      concretoArenaResult = "",
      concretoPiedraResult = "",
      concretoAceroResult = "",
      concretoAlambreResult = "",
      concretoResults = document.getElementById("concreto-results"),
      concretoArea = document.getElementById("concreto-area"),
      concretoSizes = document.getElementById("concreto-sizes"),
      concretoCemento = document.getElementById("concreto-cemento"),
      concretoArena = document.getElementById("concreto-arena"),
      concretoPiedra = document.getElementById("concreto-piedra"), 
      concretoAcero = document.getElementById("concreto-acero"),
      concretoAlambre = document.getElementById("concreto-alambre");

  concretoBtn.addEventListener("click", function(e) {
      e.preventDefault();
      /* Operación */
      concretoUnitsResult = (concretoUnits.value);

      if(concretoUnitsResult == 'metros') {
      concretoAreaResult = (concretoWidth.value * concretoHeight.value * (concretoEspesor.value / 100));
      concretoCementoResult = (concretoAreaResult * 7);
      concretoArenaResult = (concretoCementoResult * 5.29);
      concretoPiedraResult = (concretoCementoResult * 10.72);
      concretoAceroResult = (concretoWidth.value * concretoHeight.value * 0.75);
      concretoAlambreResult = (concretoAceroResult * 0.25);
      } else {
      concretoAreaResult = (concretoWidth.value * concretoHeight.value * (concretoEspesor.value / 12));
      concretoCementoResult = ((concretoAreaResult / 35.3) * 7);
      concretoArenaResult = (concretoCementoResult * 5.29);
      concretoPiedraResult = (concretoCementoResult * 10.72);
      concretoAceroResult = (concretoWidth.value * concretoHeight.value * 0.0697);
      concretoAlambreResult = (concretoAceroResult * 0.25);
      }
      
      if (concretoAreaResult > 0) {
      concretoResults.classList.add("active-results");
      concretoArea.innerHTML = concretoAreaResult.toFixed(2);
      concretoSizes.innerHTML = concretoUnitsResult + '³';
      concretoCemento.innerHTML = concretoCementoResult.toFixed(2);
      concretoArena.innerHTML = (concretoArenaResult).toFixed(1);
      concretoPiedra.innerHTML = concretoPiedraResult.toFixed(1);
      concretoAcero.innerHTML = (concretoAceroResult).toFixed(2);
      concretoAlambre.innerHTML = concretoAlambreResult.toFixed(3);
      concretoAnswer.innerHTML = "";
      } else {
      concretoResults.classList.remove("active-results");
      concretoAnswer.innerHTML = "*Dimensiones inválidas. Complete los campos.";
      }
  });
}();

/* Toping */
var toppingUnitsSelect = document.getElementById("topping-units");
var toppingUnitsText = document.getElementById("topping-units-result");

toppingUnitsSelect.addEventListener("change", (event) => {
  var toppingUnitsSelectValue = document.getElementById("topping-units");
  if (toppingUnitsSelectValue.value == 'metros') {
    var toppingUnitsSelectUnit = '(centímetros)';
  } else {
    var toppingUnitsSelectUnit = '(pulgadas)';
  }
  toppingUnitsText.innerHTML = toppingUnitsSelectUnit;
});

var calculartopping = function() {
  "use strict";
  /* Variables */
  var toppingBtn = document.getElementById("topping-btn"),
      toppingUnits = document.getElementById("topping-units"),
      toppingWidth = document.getElementById("topping-width"),
      toppingHeight = document.getElementById("topping-height"),
      toppingEspesor = document.getElementById("topping-espesor"),
      toppingAnswer = document.getElementById("topping-error"),
      toppingUnitsResult = "",
      toppingVolumenResult = "",
      toppingAreaResult = "",
      toppingCementoResult = "",
      toppingArenaResult = "",
      toppingResults = document.getElementById("topping-results"),
      toppingVolumen = document.getElementById("topping-volumen"),
      toppingVolumenSizes = document.getElementById("topping-volumen-sizes"),
      toppingArea = document.getElementById("topping-area"),
      toppingAreaSizes = document.getElementById("topping-area-sizes"),
      toppingCemento = document.getElementById("topping-cemento"),
      toppingArena = document.getElementById("topping-arena");

  toppingBtn.addEventListener("click", function(e) {
      e.preventDefault();
      /* Operación */
      toppingUnitsResult = (toppingUnits.value);

      if(toppingUnitsResult == 'metros') {
      toppingVolumenResult = (toppingWidth.value * toppingHeight.value * (toppingEspesor.value / 100));
      toppingAreaResult = (toppingWidth.value * toppingHeight.value);
      toppingCementoResult = (toppingVolumenResult * 7);
      toppingArenaResult = ((toppingVolumenResult * 35) * 2);
      } else {
      toppingVolumenResult = (toppingWidth.value * toppingHeight.value * (toppingEspesor.value / 12));
      toppingAreaResult = (toppingWidth.value * toppingHeight.value);
      toppingCementoResult = (( toppingVolumenResult / 35.3) * 7);
      toppingArenaResult = (toppingVolumenResult * 2);
      }
      
      if (toppingAreaResult > 0) {
      toppingResults.classList.add("active-results");
      toppingVolumen.innerHTML = toppingVolumenResult.toFixed(2);
      toppingArea.innerHTML = toppingAreaResult.toFixed(2);
      toppingVolumenSizes.innerHTML = toppingUnitsResult + '³';
      toppingAreaSizes.innerHTML = toppingUnitsResult + '²';
      toppingCemento.innerHTML = toppingCementoResult.toFixed(2);
      toppingArena.innerHTML = (toppingArenaResult).toFixed(1);
      toppingAnswer.innerHTML = "";
      } else {
      toppingResults.classList.remove("active-results");
      toppingAnswer.innerHTML = "*Dimensiones inválidas. Complete los campos.";
      }
  });
}();

/* Suspendido */
  
var calcularsuspendido = function() {
    "use strict";
    /* Variables */
    var suspendidoBtn = document.getElementById("suspendido-btn"),
        suspendidoWidth = document.getElementById("suspendido-width"),
        suspendidoHeight = document.getElementById("suspendido-height"),
        suspendidoAnswer = document.getElementById("suspendido-error"),
        suspendidoAreaResult = "",
        suspendidoLamina22Result = "",
        suspendidoLamina24Result = "",
        suspendidoTeeResult = "",
        suspendidoAngulo10Result = "",
        suspendidoT12Result = "",
        suspendidoClavo58Result = "",
        suspendidoAlambre14Result = "",
        suspendidoClavo114Result = "",
        suspendidoFulminanteRojoResult = "",
        suspendidoResults = document.getElementById("suspendido-results"),
        suspendidoArea = document.getElementById("suspendido-area"),
        suspendidoLamina22 = document.getElementById("suspendido-lamina-2-2"),
        suspendidoLamina24 = document.getElementById("suspendido-lamina-2-4"),
        suspendidoTee = document.getElementById("suspendido-tee"),
        suspendidoAngulo10 = document.getElementById("suspendido-angulo-10"),
        suspendidoT12 = document.getElementById("suspendido-t-12"),
        suspendidoClavo58 = document.getElementById("suspendido-clavo-5-8"),
        suspendidoAlambre14 = document.getElementById("suspendido-alambre-14"),
        suspendidoClavo114 = document.getElementById("suspendido-clavo-1-1-4"),
        suspendidoFulminanteRojo = document.getElementById("suspendido-fulminante-rojo");

    suspendidoBtn.addEventListener("click", function(e) {
        e.preventDefault();
        /* Operación */

        suspendidoAreaResult = (suspendidoWidth.value * suspendidoHeight.value);
        
        suspendidoLamina24Result = ((suspendidoAreaResult / 0.738) * 1.05);
        suspendidoLamina22Result = (suspendidoLamina24Result * 2);
        suspendidoTeeResult = (suspendidoLamina24Result / 1.05);
        suspendidoAngulo10Result = (((((suspendidoWidth.value * 2) + (suspendidoHeight.value * 2)) * (39.5)) / (12)) / (10));
        suspendidoT12Result = (suspendidoLamina24Result / 5.5);
        suspendidoClavo58Result = ((10 * suspendidoAngulo10Result) / 100);
        suspendidoAlambre14Result = (suspendidoAreaResult / 15);
        suspendidoClavo114Result = (suspendidoAreaResult / 60);
        suspendidoFulminanteRojoResult = (suspendidoClavo114Result);
        
        if (suspendidoAreaResult > 0) {
        suspendidoResults.classList.add("active-results");
        suspendidoArea.innerHTML = suspendidoAreaResult.toFixed(2);

        suspendidoLamina22.innerHTML = Math.round(suspendidoLamina22Result);
        suspendidoLamina24.innerHTML = Math.round(suspendidoLamina24Result);
        suspendidoTee.innerHTML = Math.round(suspendidoTeeResult);
        suspendidoAngulo10.innerHTML = Math.round(suspendidoAngulo10Result);
        suspendidoT12.innerHTML = Math.round(suspendidoT12Result);
        suspendidoClavo58.innerHTML = Math.round(suspendidoClavo58Result);
        suspendidoAlambre14.innerHTML = Math.round(suspendidoAlambre14Result);
        suspendidoClavo114.innerHTML = Math.round(suspendidoClavo114Result);
        suspendidoFulminanteRojo.innerHTML = Math.round(suspendidoFulminanteRojoResult);

        suspendidoAnswer.innerHTML = "";
        } else {
        suspendidoResults.classList.remove("active-results");
        suspendidoAnswer.innerHTML = "*Dimensiones inválidas. Complete los campos.";
        }
    });
}();

/* Cielo Raso Gypsum */
  
var calcularcielorasogypsum = function() {
    "use strict";
    /* Variables */
    var cielorasogypsumBtn = document.getElementById("cielorasogypsum-btn"),
        cielorasogypsumWidth = document.getElementById("cielorasogypsum-width"),
        cielorasogypsumHeight = document.getElementById("cielorasogypsum-height"),
        cielorasogypsumAnswer = document.getElementById("cielorasogypsum-error"),
        cielorasogypsumAreaResult = "",
        cielorasogypsumLamina48Result = "",
        cielorasogypsumStudResult = "",
        cielorasogypsumTrackResult = "",
        cielorasogypsumPastaResult = "",
        cielorasogypsumTornillo114Result = "",
        cielorasogypsumTornillo716Result = "",
        cielorasogypsumTape500Result = "",
        cielorasogypsumClavo34Result = "",
        cielorasogypsumFulminanteVerdeResult = "",
        cielorasogypsumResults = document.getElementById("cielorasogypsum-results"),
        cielorasogypsumArea = document.getElementById("cielorasogypsum-area"),
        cielorasogypsumLamina48 = document.getElementById("cielorasogypsum-lamina-4-8"),
        cielorasogypsumStud = document.getElementById("cielorasogypsum-stud"),
        cielorasogypsumTrack = document.getElementById("cielorasogypsum-track"),
        cielorasogypsumPasta = document.getElementById("cielorasogypsum-pasta"),
        cielorasogypsumTornillo114 = document.getElementById("cielorasogypsum-tornillo-1-1-4"),
        cielorasogypsumTornillo716 = document.getElementById("cielorasogypsum-tornillo-7-16"),
        cielorasogypsumTape500 = document.getElementById("cielorasogypsum-tape-500"),
        cielorasogypsumClavo34 = document.getElementById("cielorasogypsum-clavo-3-4"),
        cielorasogypsumFulminanteVerde = document.getElementById("cielorasogypsum-fulminante-verde");

    cielorasogypsumBtn.addEventListener("click", function(e) {
        e.preventDefault();
        /* Operación */

        cielorasogypsumAreaResult = (cielorasogypsumWidth.value * cielorasogypsumHeight.value);
        cielorasogypsumLamina48Result = ((cielorasogypsumAreaResult / 2.97) * 1.1);
        cielorasogypsumStudResult = (cielorasogypsumLamina48Result  * 2.5);
        cielorasogypsumTrackResult = (((((cielorasogypsumWidth.value * 1) + (cielorasogypsumHeight.value * 1)) * 2) * 3.28) / 10);
        cielorasogypsumPastaResult = (cielorasogypsumAreaResult / 25);
        cielorasogypsumTornillo114Result = ((cielorasogypsumLamina48Result * 35) / 100);
        cielorasogypsumTornillo716Result = (cielorasogypsumTornillo114Result / 2);
        cielorasogypsumTape500Result = (cielorasogypsumLamina48Result  / 19);
        cielorasogypsumClavo34Result = (cielorasogypsumAreaResult / 60);
        cielorasogypsumFulminanteVerdeResult = (cielorasogypsumAreaResult / 60);
        
        if (cielorasogypsumAreaResult > 0) {
        cielorasogypsumResults.classList.add("active-results");
        cielorasogypsumArea.innerHTML = cielorasogypsumAreaResult.toFixed(2);

        cielorasogypsumLamina48.innerHTML = cielorasogypsumLamina48Result.toFixed(2);
        cielorasogypsumStud.innerHTML = cielorasogypsumStudResult.toFixed(2);
        cielorasogypsumTrack.innerHTML = Math.round(cielorasogypsumTrackResult);
        cielorasogypsumPasta.innerHTML = cielorasogypsumPastaResult.toFixed(2);
        cielorasogypsumTornillo114.innerHTML = cielorasogypsumTornillo114Result.toFixed(2);
        cielorasogypsumTornillo716.innerHTML = cielorasogypsumTornillo716Result.toFixed(2);
        cielorasogypsumTape500.innerHTML = cielorasogypsumTape500Result.toFixed(2);
        cielorasogypsumClavo34.innerHTML = cielorasogypsumClavo34Result.toFixed(2);
        cielorasogypsumFulminanteVerde.innerHTML = cielorasogypsumFulminanteVerdeResult.toFixed(2);

        cielorasogypsumAnswer.innerHTML = "";
        } else {
        cielorasogypsumResults.classList.remove("active-results");
        cielorasogypsumAnswer.innerHTML = "*Dimensiones inválidas. Complete los campos.";
        }
    });
}();

/* paredesgypsum */
  
var calcularparedesgypsum = function() {
    "use strict";
    /* Variables */
    var paredesgypsumBtn = document.getElementById("paredesgypsum-btn"),
        paredesgypsumWidth = document.getElementById("paredesgypsum-width"),
        paredesgypsumHeight = document.getElementById("paredesgypsum-height"),
        paredesgypsumAnswer = document.getElementById("paredesgypsum-error"),
        paredesgypsumAreaResult = "",
        paredesgypsumLamina48Result = "",
        paredesgypsumStudResult = "",
        paredesgypsumTrackResult = "",
        paredesgypsumPastaResult = "",
        paredesgypsumTornillo114Result = "",
        paredesgypsumTornillo716Result = "",
        paredesgypsumTape500Result = "",
        paredesgypsumClavo34Result = "",
        paredesgypsumFulminanteVerdeResult = "",
        paredesgypsumResults = document.getElementById("paredesgypsum-results"),
        paredesgypsumArea = document.getElementById("paredesgypsum-area"),
        paredesgypsumLamina48 = document.getElementById("paredesgypsum-lamina-4-8"),
        paredesgypsumStud = document.getElementById("paredesgypsum-stud"),
        paredesgypsumTrack = document.getElementById("paredesgypsum-track"),
        paredesgypsumPasta = document.getElementById("paredesgypsum-pasta"),
        paredesgypsumTornillo114 = document.getElementById("paredesgypsum-tornillo-1-1-4"),
        paredesgypsumTornillo716 = document.getElementById("paredesgypsum-tornillo-7-16"),
        paredesgypsumTape500 = document.getElementById("paredesgypsum-tape-500"),
        paredesgypsumClavo34 = document.getElementById("paredesgypsum-clavo-3-4"),
        paredesgypsumFulminanteVerde = document.getElementById("paredesgypsum-fulminante-verde");

    paredesgypsumBtn.addEventListener("click", function(e) {
        e.preventDefault();
        /* Operación */

        paredesgypsumAreaResult = (paredesgypsumWidth.value * paredesgypsumHeight.value);
        paredesgypsumLamina48Result = (((paredesgypsumAreaResult / 2.97) * 1.05) * 2);
        paredesgypsumStudResult = ((paredesgypsumLamina48Result  * 2.5) / 2);
        paredesgypsumTrackResult = (((((paredesgypsumWidth.value * 1) + (paredesgypsumHeight.value * 1)) * 2) * 3.28) / 10);
        paredesgypsumPastaResult = ((paredesgypsumAreaResult / 25) * 2);
        paredesgypsumTornillo114Result = ((paredesgypsumLamina48Result * 35) / 100);
        paredesgypsumTornillo716Result = ((paredesgypsumTornillo114Result / 2) / 2);
        paredesgypsumTape500Result = ((paredesgypsumLamina48Result  / 21) * 2);
        paredesgypsumClavo34Result = ((paredesgypsumAreaResult / 60) * 2);
        paredesgypsumFulminanteVerdeResult = ((paredesgypsumAreaResult / 60) * 2);
        
        if (paredesgypsumAreaResult > 0) {
        paredesgypsumResults.classList.add("active-results");
        paredesgypsumArea.innerHTML = paredesgypsumAreaResult.toFixed(2);

        paredesgypsumLamina48.innerHTML = paredesgypsumLamina48Result.toFixed(2);
        paredesgypsumStud.innerHTML = paredesgypsumStudResult.toFixed(2);
        paredesgypsumTrack.innerHTML = paredesgypsumTrackResult.toFixed(2);
        paredesgypsumPasta.innerHTML = paredesgypsumPastaResult.toFixed(2);
        paredesgypsumTornillo114.innerHTML = paredesgypsumTornillo114Result.toFixed(2);
        paredesgypsumTornillo716.innerHTML = paredesgypsumTornillo716Result.toFixed(2);
        paredesgypsumTape500.innerHTML = paredesgypsumTape500Result.toFixed(2);
        paredesgypsumClavo34.innerHTML = paredesgypsumClavo34Result.toFixed(2);
        paredesgypsumFulminanteVerde.innerHTML = paredesgypsumFulminanteVerdeResult.toFixed(2);

        paredesgypsumAnswer.innerHTML = "";
        } else {
        paredesgypsumResults.classList.remove("active-results");
        paredesgypsumAnswer.innerHTML = "*Dimensiones inválidas. Complete los campos.";
        }
    });
}();